/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React from 'react';
import { SidenavBarSVG } from '../img/GlobalSVG';
//import FEATURES from 'src/services/features';

const sidebarMenu = [
  {
    id: 0,
    text: 'Dashboard',
    route: '/member/dashboard',
    menuImg1: <SidenavBarSVG.DashboardSVG />,
    menuImg2: <SidenavBarSVG.DashboardSVG />,
    alt: 'Dashboard',
  },
  {
    id: 1,
    text: 'ID Cards',
    route: '/member/my-id-cards',
    menuImg1: <SidenavBarSVG.IDCardSVG />,
    menuImg2: <SidenavBarSVG.IDCardSVG />,
    alt: 'Id Card',
  },
  {
    id: 2,
    text: 'Coverages',
    route: '/member/coverage',
    menuImg1: <SidenavBarSVG.CoverageSVG />,
    menuImg2: <SidenavBarSVG.CoverageSVG />,
    alt: 'Coverage',
  },
  {
    id: 3,
    text: 'Claims',
    route: '/member/claims',
    menuImg1: <SidenavBarSVG.ClaimsSVG />,
    menuImg2: <SidenavBarSVG.ClaimsSVG />,
    alt: 'Claims',
  },
  {
    id: 4,
    text: 'Accounts',
    route: '/member/accounts',
    menuImg1: <SidenavBarSVG.AccountSVG />,
    menuImg2: <SidenavBarSVG.AccountSVG />,
    alt: 'Account',
  },
  {
    id: 5,
    text: 'Find Provider',
    route: '/member/find-provider',
    menuImg1: <SidenavBarSVG.FindProviderSVG />,
    menuImg2: <SidenavBarSVG.FindProviderSVG />,
    alt: 'Find Provider',
  },
  {
    id: 6,
    text: 'Resources',
    route: '/member/allresources',
    menuImg1: <SidenavBarSVG.ResourcesSVG />,
    menuImg2: <SidenavBarSVG.ResourcesSVG />,
    alt: 'Resources',
  },
  {
    id: 7,
    text: 'Document',
    route: '/member/messages-documents-notifications',
    menuImg1: <SidenavBarSVG.UploadDocumentSVG />,
    menuImg2: <SidenavBarSVG.UploadDocumentSVG />,
    alt: 'Document',
  },
  {
    id: 8,
    text: 'Estimate Cost',
    route: '/member/price-compare',
    menuImg1: <SidenavBarSVG.EstimateCosttSVG />,
    menuImg2: <SidenavBarSVG.EstimateCosttSVG />,
    alt: 'Estimate Cost',
  },
];

export default sidebarMenu;
